/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerAccountInfo
 */
export interface CustomerAccountInfo {
    /**
     * Additional information about the account optionally provided by the 3-D Secure Requestor
     * @type {string}
     * @memberof CustomerAccountInfo
     */
    customerAccountId?: string;
    /**
     * The number of customer transactions made over the last six months (last 180 days)
     * @type {string}
     * @memberof CustomerAccountInfo
     */
    numberOfPurchase180Days?: string;
    /**
     * Number of accepted or abandoned transactions in the last year on the customer account
     * @type {string}
     * @memberof CustomerAccountInfo
     */
    numberOfTransactionYear?: string;
    /**
     * The customer account creation date. Format: YYYY/MM/DD
     * @type {string}
     * @memberof CustomerAccountInfo
     */
    customerAccountCreationDate?: string;
    /**
     * The number of add card attempts in 24 hours
     * @type {string}
     * @memberof CustomerAccountInfo
     */
    numberOfAttemptsAddCard24Hours?: string;
    /**
     * Specifies whether a suspicious activity is detected on customer account. Possible values: true or false.
     * @type {string}
     * @memberof CustomerAccountInfo
     */
    suspiciousActivityIndicator?: string;
    /**
     * Number of abandoned or successful transactions in the last 24 hours on the customer account
     * @type {string}
     * @memberof CustomerAccountInfo
     */
    numberOfTransaction24Hours?: string;
    /**
     * Last date the customer account was changed. Format: YYYY/MM/DD
     * @type {string}
     * @memberof CustomerAccountInfo
     */
    customerAccountChangeDate?: string;
    /**
     * Date of last change of password of the customer account. Format: YYYY/MM/DD
     * @type {string}
     * @memberof CustomerAccountInfo
     */
    passwordChangeDate?: string;
    /**
     * Date of last added form of payment made to account. For example a new card registered to the account. Format: YYYY/MM/DD
     * @type {string}
     * @memberof CustomerAccountInfo
     */
    addPaymentMeanDate?: string;
}

/**
 * Check if a given object implements the CustomerAccountInfo interface.
 */
export function instanceOfCustomerAccountInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CustomerAccountInfoFromJSON(json: any): CustomerAccountInfo {
    return CustomerAccountInfoFromJSONTyped(json, false);
}

export function CustomerAccountInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerAccountInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customerAccountId': !exists(json, 'customerAccountId') ? undefined : json['customerAccountId'],
        'numberOfPurchase180Days': !exists(json, 'numberOfPurchase180Days') ? undefined : json['numberOfPurchase180Days'],
        'numberOfTransactionYear': !exists(json, 'numberOfTransactionYear') ? undefined : json['numberOfTransactionYear'],
        'customerAccountCreationDate': !exists(json, 'customerAccountCreationDate') ? undefined : json['customerAccountCreationDate'],
        'numberOfAttemptsAddCard24Hours': !exists(json, 'numberOfAttemptsAddCard24Hours') ? undefined : json['numberOfAttemptsAddCard24Hours'],
        'suspiciousActivityIndicator': !exists(json, 'suspiciousActivityIndicator') ? undefined : json['suspiciousActivityIndicator'],
        'numberOfTransaction24Hours': !exists(json, 'numberOfTransaction24Hours') ? undefined : json['numberOfTransaction24Hours'],
        'customerAccountChangeDate': !exists(json, 'customerAccountChangeDate') ? undefined : json['customerAccountChangeDate'],
        'passwordChangeDate': !exists(json, 'passwordChangeDate') ? undefined : json['passwordChangeDate'],
        'addPaymentMeanDate': !exists(json, 'addPaymentMeanDate') ? undefined : json['addPaymentMeanDate'],
    };
}

export function CustomerAccountInfoToJSON(value?: CustomerAccountInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'customerAccountId': value.customerAccountId,
        'numberOfPurchase180Days': value.numberOfPurchase180Days,
        'numberOfTransactionYear': value.numberOfTransactionYear,
        'customerAccountCreationDate': value.customerAccountCreationDate,
        'numberOfAttemptsAddCard24Hours': value.numberOfAttemptsAddCard24Hours,
        'suspiciousActivityIndicator': value.suspiciousActivityIndicator,
        'numberOfTransaction24Hours': value.numberOfTransaction24Hours,
        'customerAccountChangeDate': value.customerAccountChangeDate,
        'passwordChangeDate': value.passwordChangeDate,
        'addPaymentMeanDate': value.addPaymentMeanDate,
    };
}

